export default "__VITE_ASSET__BrgBqQ7F__"